import { render, staticRenderFns } from "./MeetingMinutes.vue?vue&type=template&id=23ffb995&scoped=true&"
import script from "./MeetingMinutes.vue?vue&type=script&lang=js&"
export * from "./MeetingMinutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffb995",
  null
  
)

export default component.exports